var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98611 15.6006L1.16545 7.14054C1.16545 7.14054 -0.212715 1.04114 4.98611 1.0002C10.1849 0.959266 8.84497 7.15692 8.84497 7.15692L4.98611 15.6006Z",
    fill: "#A3A3A3",
    stroke: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99948 6.84329C6.25046 6.84329 7.26458 5.86216 7.26458 4.65187C7.26458 3.44158 6.25046 2.46045 4.99948 2.46045C3.7485 2.46045 2.73438 3.44158 2.73438 4.65187C2.73438 5.86216 3.7485 6.84329 4.99948 6.84329Z",
    fill: "#303030"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99974 6.70661C6.17537 6.70661 7.1284 5.78657 7.1284 4.65165C7.1284 3.51672 6.17537 2.59668 4.99974 2.59668C3.82412 2.59668 2.87109 3.51672 2.87109 4.65165C2.87109 5.78657 3.82412 6.70661 4.99974 6.70661Z",
    stroke: "#A3A3A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDot);
export default __webpack_public_path__ + "static/media/map-dot.26a55490edbf8c476454b6e31f738d98.svg";
export { ForwardRef as ReactComponent };